export const gitCommit = '1d502cfb'
